import React, { useEffect, useState } from "react";
import crmservices from '../../wsclient';
import SwapDeviceView from "./SwapDeviceView";
import { useTranslation } from "react-i18next";
import SwapDeviceDetailView from "./SwapDeviceDetailView";
import { createCustomFieldObj, getCustomFieldByKey, sleep } from "../../utils/util";
import { httpBackOfficeUtil } from "../../wsclient/crmservices/httpBackOfficeUtil";
import SwapDeviceInputView from "./SwapDeviceInputView";
import ConfirmComponent from "../../components/Confirm";
import UploadFile from "../../components/UploadFile";

const MAXIUM_FILE = 3;
export default function SwapDeviceController(props) {
    const organisation_id = document._portalConfig.organisation_id;
    const typeId = props.activityTypes.swapping;
    const { t } = useTranslation();
    const [listSwapDevice, setListSwapDevice] = useState([]); //list of activty remove
    const [showLoadingSwapDevice, setShowLoadingSwapDevice] = useState(true);
    const [showExecutionProcess, setShowExecutionProcess] = useState(false);
    //detail
    const [deviceRemoved, setDeviceRemoved] = useState(null); //serial number of device removed
    const [deviceAdded, setDeviceAdded] = useState(null); //serial number of device added
    const [subscriptionId, setSubscriptionId] = useState(null);
    const [showSerialInput, setShowSerialInput] = useState(false);
    const [showDetail, setShowDetail] = useState(false);
    const [showUploadFile, setShowUploadFile] = useState(false);
    const [filesUpload, setFilesUpload] = useState([]);
    const [files, setFiles] = useState([]);
    // parse to modal detail
    const [device, setDevice] = useState(null); //object device removed
    const [device2, setDevice2] = useState(null); //object device added
    const [activity, setActivity] = useState(null);
    // update LinearBuffer
    const [actionState, setActionState] = useState(null);

    const [paging, setPaging] = useState({
        page: 1,
        size: 10,
        total: 0,
        has_more: false
    });

    const setShowProcessing = props.setShowProcessing;
    const showMessage = props.showMessage;

    useEffect(() => {
        if (typeId)
            onLoadListSwapDevice();
    }, [typeId]);

    // function to load list of activities remove device
    const onLoadListSwapDevice = async (page, size) => {
        setShowLoadingSwapDevice(true);
        let data = [];
        let _paging = {
            page: 1,
            size: 10,
            total: 0
        }
        try {
            const result = await crmservices.activities.getActivities({
                type_id: typeId,
                page: page ? page : paging.page,
                size: size ? size : paging.size,
                state: "PENDING",
                include_total: true
            });
            if (result.code === 'OK') {
                console.log("result:", result);
                data = result.data.content ? result.data.content : [];
                _paging = result.data.paging;
                if (_paging.size < paging.size) {
                    _paging.size = paging.size
                }
            }
            setListSwapDevice(data);
            setPaging(_paging)
        } catch (error) {
            console.log("load activity remove device error:", error);
        }
        setShowLoadingSwapDevice(false);
    }

    const handleChangePage = async (page) => {
        console.log("AAA page:", page);
        await onLoadListSwapDevice(page);
    }

    const handleChangeRowsPerPage = async (size) => {
        console.log("AAA size:", size);
        await onLoadListSwapDevice(1, size);
    }

    const onSubmitSerialNumber = (data) => {
        console.log("AAA serial number:", data)
        setDeviceRemoved(data.removedSerial);
        setDeviceAdded(data.addedSerial);
        setShowSerialInput(false);
        //deviceRemoved still at previous state
        onShowDetail(data.removedSerial, data.addedSerial);
    }

    const onShowSerialInput = async (activity) => {
        //get detail activity to get address
        setShowProcessing(true);
        try {
            const result = await crmservices.activities.getActivity(activity.id);
            if (result.code == 'OK') {
                let activityData = result.data;
                // get contact detail
                if (activityData.contact) {
                    var result2 = await crmservices.contacts.getContact(activityData.contact.id);
                    if (result2.code == 'OK') {
                        activityData = { ...activityData, contact: { ...result2.data, id: activityData.contact.id } }
                    }
                }
                //
                setActivity(activityData)
                setShowSerialInput(true)
            } else {
                showMessage({
                    status: true,
                    message: t('NO_ACTIVITY_FOUND'), //TODO: correct message
                });
            }
        } catch (ex) {
            console.log("onShowDetail ex:", ex);
            showMessage({
                status: true,
                message: t('EXCEPTION_PROCESS'),
            });
        }
        setShowProcessing(false);
    }

    //function to handle show detail
    const onShowDetail = async (removedSerial, addedSerial) => {
        setFiles([]);
        console.log("Serial number of removed device:", removedSerial)
        console.log("Serial number of added device:", addedSerial)
        let contactId = activity.contact ? activity.contact.id : null;
        if (!contactId)
            showMessage({
                status: true,
                message: t('NO_CONTACT_FOUND'), //TODO: correct message
            });
        if (removedSerial && contactId) {
            setShowProcessing(true);
            try {
                const result = await crmservices.subscriptions.getDevice({
                    contact_id: contactId,
                    serial_number: removedSerial,
                    in_warehouse: false,
                })
                if (result.code == 'OK' && result.data.content && result.data.content.length > 0) {
                    let device = result.data.content[0];
                    setDevice(device);
                    if (device.subscriptions && device.subscriptions.length > 0) {
                        let subId = device.subscriptions[0].id
                        setSubscriptionId(subId);
                    }
                    await getSubscriptionDevice(addedSerial);
                } else {
                    showMessage({
                        status: true,
                        message: t('NO_DEVICE_FOUND'), //TODO: correct message
                    });
                }
            } catch (ex) {
                console.log("onShowDetail ex:", ex);
                showMessage({
                    status: true,
                    message: t('EXCEPTION_PROCESS'),
                });
            }
            setShowProcessing(false);
        }
    }

    //check if added device is allowd by subscription
    const getSubscriptionDevice = async (addedSerial) => {
        try {
            let myUserId = httpBackOfficeUtil.getSession().sub;
            const result = await crmservices.subscriptions.getDevice({
                owner_id: organisation_id,
                serial_number: addedSerial,
                include_custom_fields: true,
                custom_fields: `contractor;${myUserId}`,
                include_subscription: false
            });
            if (result.code === 'OK' && result.data.content && result.data.content.length > 0) {
                setDevice2(result.data.content[0])
                setShowDetail(true);
            } else {
                showMessage({
                    status: true,
                    message: t('DEVICE_NOT_ALLOWED'),
                });
            }
        } catch (ex) {
            console.log("getSubscriptionDevice ex:", ex);
            showMessage({
                status: true,
                message: t('EXCEPTION_PROCESS'),
            });
        }
    }

    // call when subscription action state is executed
    const onUpdateActivity = async (note) => {
        let custom_fields = activity.custom_fields ? activity.custom_fields : [];
        console.log("custom_fields:", custom_fields);
        custom_fields = createCustomFieldObj(custom_fields, "device_removed", deviceRemoved);
        custom_fields = createCustomFieldObj(custom_fields, "device_added", deviceAdded);
        if (note)
            custom_fields = createCustomFieldObj(custom_fields, "notes", note);
        const fileUploaded = await onUploadFile();
        let strFileUploaded = fileUploaded && fileUploaded.length > 0 ? fileUploaded.join(",") : null;
        if (strFileUploaded) {
            let fileCustomFields = getCustomFieldByKey(custom_fields, 'attachments_file_id');
            if (fileCustomFields) {
                fileCustomFields = fileCustomFields + "," + strFileUploaded
            } else {
                fileCustomFields = strFileUploaded;
            }
            custom_fields.push({
                key: 'attachments_file_id',
                value: fileCustomFields
            })
        }
        try {
            const result = await crmservices.activities.updateActivity({ activity_id: activity.id, state: "COMPLETED", custom_fields: custom_fields });
            if (result.code == 'OK') {
                onLoadListSwapDevice(paging.page, paging.size);
                // showMessage({ status: true, message: t('UPDATE_ACTIVITY_SUCCESS') })
            }
        } catch (ex) {
            console.log("onUpdateActivity ex:", ex);
        }
    }

    // get state to use in updateActivityIfExecuted function
    const getSubscriptionActionState = async (actionId) => {
        let state = null;
        try {
            const result = await crmservices.subscriptions.getSubscriptionAction({
                action_id: actionId
            });
            if (result.code === 'OK') {
                state = result.data.state;
                console.log("SubscriptionActionState: ", state);
            }
        } catch (error) {
            state = 'EXCEPTION'
            console.log("get updatingState error:", error);
        }
        return state
    }

    const updateActivityIfExecuted = async (actionId, note) => {
        // setShowProcessing Subscriptions action is being executed
        setShowExecutionProcess(true);
        let attempts = 3;
        let currentState;
        while (currentState !== "EXECUTED" && attempts > 0) {
            currentState = await getSubscriptionActionState(actionId)
            if (currentState !== "PENDING_VERIFICATION") break; //REJECTED || EXEPTION ...
            if (attempts != 3) await sleep(3000); //delay 3s after first attempt
            attempts--;
        }
        if (currentState === "EXECUTED") {
            await onUpdateActivity(note);
            props.onReloadSwapList();
            //update device //co can phai tach ham khong nhi ??
            let custom_fields = device.custom_fields ? device.custom_fields : [];
            custom_fields = createCustomFieldObj(custom_fields, "contractor_name", httpBackOfficeUtil.getSession().preferred_username);
            if (device.id)
                crmservices.subscriptions.updateDevice({ custom_fields: custom_fields }, device.id);
        }
        setActionState(currentState);
        await sleep(500);
        setShowExecutionProcess(false);
    }

    const onSubmitSwapDevice = async (note) => {
        console.log("note:", note);
        console.log('subscriptionId:', subscriptionId);
        if (subscriptionId && device.id && device2.id) {
            try {
                setShowProcessing(true);
                const result = await crmservices.subscriptions.updateSubscriptionDevice({ action: "REPLACE", replaced_by_device_id: device2.id }, subscriptionId, device.id);
                setShowProcessing(false);
                if (result.code == 'OK') {
                    setShowDetail(false);
                    showMessage({ status: true, message: t('SWAP_SUCCESS') });
                    let actionId = result.data.id;
                    await updateActivityIfExecuted(actionId, note);
                }
                else if (result.code == 'CANNOTEXECUTEACTIONOVERDUEAMOUNTEXCEPTION') {
                    showMessage({
                        status: true,
                        message: t('SWAP_DEVICE_CANNOTEXECUTEACTIONOVERDUEAMOUNTEXCEPTION'),
                    });
                }
                else {
                    showMessage({
                        status: true,
                        message: t('UNKNOWN'), //TODO: correct message
                    });
                }
            } catch (ex) {
                console.log("onSubmitSwapDevice ex:", ex);
            }
        }
    }

    const onUploadFile = async () => {
        console.log("AAAA onUploadFile files: ", files)
        let _filesUploaded = [];
        try {
            console.log("files:", files)
            if (files.length > 0) {
                for (let i = 0; i < files.length; i++) {
                    console.log("files[i]:", files[i])
                    const result = await crmservices.attachments.uploadFiles({ file: files[i], disalbedContentType: true });
                    console.log("AAAA onUploadFile result: ", result)
                    if (result.code == 'OK' && result.data.id) {
                        const addContactResult = await onAddContactAttachment(result.data.id);
                        if (addContactResult) {
                            _filesUploaded.push(result.data.id)
                        }
                    }
                }
            }
        } catch (error) {
            console.log("onUploadFile exception:", error);
        }
        return _filesUploaded
    }

    const onAddContactAttachment = async (file_id) => {
        let successfull = false;
        try {
            const contactId = activity.contact.id;
            let result = await crmservices.attachments.addContactAttachment({
                file_id: file_id,
                contact_id: contactId
            });
            if (result.code == 'OK') {
                successfull = true;
            }
            console.log("AAAA onAddContactAttachment result: ", result)
        } catch (error) {
            console.log("onAddContactAttachment exception:", error);
        }
        return successfull;
    }

    const onDeleteFile = (file) => {
        console.log("file==", file);
        const filesExist = files.filter(f => f.id !== file.id);
        setFiles(filesExist);
    }

    const uploadFiles = (files) => {
        if (files.length > MAXIUM_FILE) {
            showMessage({ status: true, message: t('error_max_files') })
            return false;
        }
        setFilesUpload(files);
    }

    const onSaveFilesState = () => {
        if (filesUpload && filesUpload.length > 0) setFiles(filesUpload);
        setShowUploadFile(false);
    }

    return (
        <>
            <SwapDeviceView
                listSwapDevice={listSwapDevice}
                paging={paging}
                showLoadingSwapDevice={showLoadingSwapDevice}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                onShowSerialInput={onShowSerialInput}
                showExecutionProcess={showExecutionProcess}
                actionState={actionState}
            />
            {showSerialInput && <SwapDeviceInputView
                isOpen={showSerialInput}
                onClose={() => setShowSerialInput(false)}
                onSubmit={onSubmitSerialNumber}
                device={device}
                activity={activity}
            />}
            {showDetail && <SwapDeviceDetailView
                isOpen={showDetail}
                onClose={() => setShowDetail(false)}
                onSubmit={onSubmitSwapDevice}
                device={device}
                device2={device2}
                activity={activity}
                files={files}
                setShowUploadFile={setShowUploadFile}
                onDeleteFile={onDeleteFile}
            />}
            {showUploadFile && <ConfirmComponent isOpen={showUploadFile} enableCloseButton={true}
                title={'Upload File'}
                otherMessage={<UploadFile onUploadFile={uploadFiles} isMultipleFile={true} />}
                onClose={() => setShowUploadFile(false)}
                onAction={() => onSaveFilesState()}
            />}
        </>
    )
}